module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"export":"CSV出力"},"msg":{"export":{"failed":"CSVの出力に失敗しました。"}}},"en":{"button":{"export":"Export CSV"},"msg":{"export":{"failed":"Failed to output CSV."}}}}')
  delete Component.options._Ctor
}
